export const locale = {
    lang: 'en',
    data: {
        ALL_CARDS: 'All cards',
        LIST_CARDS: 'Cards from lists',
        TYPE: 'Type',
        POINTS: 'Votes',
        CATEGORIES: 'Colors',
        CARDS_HAVE: 'Cards that have',
        OF: 'than',
        CHOOSE_CARDS: 'Choose cards',
        PLUS: 'more',
        MOINS: 'less',
        SAVE: 'Save',
        CANCEL: 'Cancel',
    }
};
